import { OpenIdConnectService } from "./oidc/open-id-connect.service";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { MatDialog, MatDialogRef } from "@angular/material";
import { environment } from "../../environments/environment";
import { SessionTimeoutComponent } from "../components/session-timeout/session-timeout.component";
import * as _config from './config';

export class SessionTimer {
    popup: Window;
    sessionTimeoutDialogRef: MatDialogRef<SessionTimeoutComponent>;

    constructor(private oidcService: OpenIdConnectService, private idle: Idle, private keepAlive: Keepalive, private dialog: MatDialog) { }

    startTimeout() {
        var idleTime = environment.production ? 60 * 55 : 60 * 28; // 55 minutes or 30 seconds
        this.idle.setIdle(idleTime);

        var timeoutTime = environment.production ? 300 : 120; // 5 minutes or 2 minutes
        this.idle.setTimeout(timeoutTime);

        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onTimeoutWarning.subscribe((countdown) => {
            if (!this.sessionTimeoutDialogRef) {
                this.sessionTimeoutDialogRef = this.dialog.open(SessionTimeoutComponent, {
                    disableClose: true,
                    data: { timer: countdown }
                });
            }

            this.sessionTimeoutDialogRef.afterOpen().subscribe(() => {
                this.popup = window.open("", 'logoff', "width=350, height=225, location=no, menubar=no, resizable=yes, scrollbars=no, status=no, titlebar=no, toolbar=no", false);

                if (this.popup) {
                    this.popup.document.write(
                        "<!DOCTYPE html>\r\n<html><head><title>Session Expiring | " + _config.appTitle + "</title><script language='JavaScript'>" +
                        "function checkOpener() { if (!window.opener) window.close(); } " +
                        "function keepAlive() { window.opener.sessionAction('alive'); } " +
                        "function logOff() { window.opener.sessionAction('logoff'); } " +
                        "checkOpener(); " +
                        "</script><style>" +
                        "h1, html, body, header, section { margin: 0; padding: 0; border-collapse: collapse; color: #333333; } body { font-family: 'Arial' } h1 { margin-left: 15px; text-transform: uppercase; display: inline-block; vertical-align: top; } img { width: 100px; margin-left: 15px; } header { background-color: #efefef; vertical-align: top; padding: 0 0 10px; } article { padding: 0 15px; } " +
                        "header section { color: white; background-color: #313131; font-size: .75em; text-align: right; margin-bottom: 10px; padding: 7px 10px; } " +
                        "button { margin: 0 5px; padding: 3px 5px; color: white; background-color: #505050; cursor: pointer; border: none; border-collapse: collapse; } button:hover { background-color: #313131; }" +
                        "</style></head><body>" +
                        "<header><section>" + this.oidcService.profile.name + "</section><img src='" + _config.virtualDirRoot + "images/bdo.svg' /><h1>" + _config.appTitle + "</h1></header>" +
                        "<article><h3>Your session is about to expire.</h3><p>Please choose an option:</p>" +
                        "<button onclick='keepAlive()'>I'm Still Working</button><button onclick='logOff()'>I'm Done for Now</button>" +
                        "</article></body></html>");

                    this.popup.opener = window;
                }
            });

            this.sessionTimeoutDialogRef.afterClosed().subscribe(val => {
                if (this.popup) {
                    try {
                        if (!this.popup.closed) {
                            this.popup.close();
                        }
                    } catch (ex) {
                    }
                }
                if (!val) {
                    this.oidcService.triggerSignOut();
                } else {
                    this.resetTimeout();
                }
                this.sessionTimeoutDialogRef = null; // resets dialog
            })
        });

        this.idle.onTimeout.subscribe(() => {
            this.oidcService.triggerSignOut();
        });

        this.resetTimeout();

        (<any>window).sessionAction = this.sessionFunc.bind(this);
    }

    sessionFunc(action) {
        if (action === 'alive') {
            this.sessionTimeoutDialogRef.close(true);
        } else {
            this.sessionTimeoutDialogRef.close(false);
        }
    }

    resetTimeout() {
        this.idle.watch();
    }
}
